/* Keep your basket (Malou, 2026-10-01). Markup and styles: snippets/bokja-basket-save.liquid.

   1. On every page: if this visit arrived from Pinterest (utm_source=pinterest, Pinterest's epik click
      id, or a pinterest.* / pin.it referrer) or from a Meta ad (utm_medium paid with an ig / instagram /
      fb / facebook / meta source, or the Meta catalogue's utm_content=Facebook_UA), remember it for the
      tab (sessionStorage) and mark the page with html.bokja-basket-ask. The snippet's CSS shows the line
      only then, so the drawer can re-render freely.
   2. On submit: read /cart.js and send the basket to Klaviyo as a "Saved Basket" event (the profile
      carries saved_basket_source and arrival_source). No newsletter sign-up since 31 Oct (James). If the visitor allowed marketing cookies, the browser is also identified
      to klaviyo.js, so their later adds and views feed the Added to Cart, Viewed Product and Abandoned
      Checkout flows like any known visitor. The flow "Saved
      basket (Pinterest and Meta ads)" turns it into the email. CartURL is a Shopify cart permalink, so
      "Return to your basket" rebuilds the same basket on any device.
   3. (James, 2026-10-31: "once they click Add to Cart, it triggers a pop-up saying, Save your cart and
      receive your discount ... only for Pinterest, Instagram and Facebook browsers", after October showed
      about 140 ad-visitor baskets, 26 checkouts started and none paid.) The first successful Add to Cart
      of the visit opens a pop-up with the same field, once per tab, never for a signed-in customer or
      after a save. Arrivals now also cover organic Instagram and Facebook visits and their in-app
      browsers. The offer is a unique 10% code, sent in the saved-basket email (Offer on the event).
   Fail-safe: any error shows the note and never touches the cart. */
(function () {
  if (window.__bokjaBasketSaveBound) return;
  window.__bokjaBasketSaveBound = true;

  var ASK = 'bokja-basket-ask';
  var SAVED = 'bokja-basket-saved';
  var META = ['ig', 'instagram', 'fb', 'facebook', 'meta'];

  function arrival() {
    var q = new URLSearchParams(window.location.search);
    var src = (q.get('utm_source') || '').toLowerCase();
    var med = (q.get('utm_medium') || '').toLowerCase();
    var content = (q.get('utm_content') || '').toLowerCase();
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch (e) { ref = ''; }
    if (ref === window.location.hostname) ref = '';
    var ua = navigator.userAgent || '';
    if (src === 'pinterest' || q.has('epik') || /(^|\.)pinterest\.[a-z.]+$/.test(ref) || ref === 'pin.it' || /Pinterest/i.test(ua)) return 'pinterest';
    if (META.indexOf(src) !== -1 && /paid|cpc|ads?$/.test(med)) return 'meta';
    if (src === 'facebook' && content === 'facebook_ua') return 'meta';
    // organic Instagram and Facebook: tagged links, referrers and the apps' own in-app browsers
    if (src === 'ig' || src === 'instagram' || /(^|\.)instagram\.com$/.test(ref) || /Instagram/.test(ua)) return 'instagram';
    if (src === 'fb' || src === 'facebook' || /(^|\.)facebook\.com$/.test(ref) || /FBAN|FBAV|FB_IAB/.test(ua)) return 'facebook';
    return '';
  }

  function store(k, v) { try { if (v == null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v); } catch (e) { /* private mode: this page only */ } }
  function read(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }

  var source = arrival();
  if (source) store(ASK, source); else source = read(ASK) || '';
  if (source) document.documentElement.classList.add('bokja-basket-ask');
  if (read(SAVED)) document.documentElement.classList.add('bokja-basket-saved');

  // 3. The pop-up on the first Add to Cart (James, 2026-10-31). Copy: James's words, verbatim.
  var POPPED = 'bokja-basket-popped';
  var COMPANY = 'U9n7Vj';
  var LIST = 'RAVrcm';
  var POP_CSS = [
    '.bokja-basket-pop{border:none;padding:0;margin:auto;max-width:min(420px,calc(100vw - 32px));width:100%;background:#FBFBF6;color:#1a1a1a;border-radius:0;font-family:inherit}',
    '.bokja-basket-pop::backdrop{background:rgba(26,26,26,.45)}',
    '.bokja-basket-pop__panel{position:relative;padding:36px 28px 28px}',
    '.bokja-basket-pop__close{position:absolute;top:8px;right:8px;width:40px;height:40px;background:none;border:none;color:#1a1a1a;font-size:24px;line-height:1;cursor:pointer}',
    '.bokja-basket-pop__title{margin:0 24px 0 0;font-size:20px;line-height:1.35;font-weight:400;letter-spacing:.01em}',
    '.bokja-basket-pop__field{display:flex;align-items:center;margin-top:20px;border-bottom:1px solid rgba(26,26,26,.3)}',
    '.bokja-basket-pop__field:focus-within{border-bottom-color:#1a1a1a}',
    '.bokja-basket-pop__field input{flex:1;min-width:0;background:none;border:none;border-radius:0;color:#1a1a1a;font:inherit;font-size:16px;letter-spacing:.02em;padding:12px 0;outline:none}',
    '.bokja-basket-pop__field input::placeholder{color:rgba(26,26,26,.45)}',
    '.bokja-basket-pop__field button{background:none;border:none;color:#1a1a1a;font-size:22px;line-height:1;cursor:pointer;padding:0 2px 0 12px}',
    '.bokja-basket-pop__field button:disabled{opacity:.4;cursor:default}',
    '.bokja-basket-pop__small{margin:12px 0 0;font-size:12px;letter-spacing:.02em;opacity:.7}',
    '.bokja-basket-pop__done{display:none}',
    '.bokja-basket-pop__done-text{margin:0 24px 0 0;font-size:16px;line-height:1.5}',
    '.bokja-basket-pop__go{display:block;width:100%;margin-top:20px;padding:15px 20px;background:#1a1a1a;color:#FBFBF6;border:none;border-radius:0;font:inherit;font-size:12px;letter-spacing:.14em;text-transform:uppercase;cursor:pointer}',
    'html.bokja-basket-saved .bokja-basket-pop__form{display:none}',
    'html.bokja-basket-saved .bokja-basket-pop__done{display:block}'
  ].join('\n');

  // Exposure tracking (2 Nov 2026): the Shopify custom event bokja:basket_popup, read by the GA4 custom pixel
  // (hub scripts/pixels/ga4-ecommerce-custom-pixel.js). Steps: shown, dismissed, submitted, code_issued,
  // code_failed (reason), code_applied (applied), email_requested, email_failed. Never the email address or
  // the code. Same guard as bokja:product_swapped (snippets/bokja-product-swap.liquid): no Shopify.analytics,
  // no event, never an error.
  function publish(step, place, extra) {
    try {
      var api = window.Shopify && window.Shopify.analytics;
      if (!api || typeof api.publish !== 'function') return;
      var payload = { step: step, source: source || 'unknown', place: place };
      if (extra) for (var k in extra) payload[k] = extra[k];
      api.publish('bokja:basket_popup', payload);
    } catch (e) {}
  }

  function signedIn() {
    try { return !!(window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId); } catch (e) { return false; }
  }

  function buildPop() {
    var style = document.createElement('style');
    style.textContent = POP_CSS;
    document.head.appendChild(style);
    var dialog = document.createElement('dialog');
    dialog.className = 'bokja-basket-pop';
    dialog.setAttribute('aria-labelledby', 'bokja-basket-pop-title');
    dialog.innerHTML =
      '<div class="bokja-basket-pop__panel" data-bokja-basket-save data-bokja-basket-place="popup" data-klaviyo-company="' + COMPANY + '" data-klaviyo-list="' + LIST + '">' +
        '<button type="button" class="bokja-basket-pop__close" aria-label="Close" data-bokja-basket-pop-close>&times;</button>' +
        '<form class="bokja-basket-pop__form" novalidate>' +
          '<p class="bokja-basket-pop__title" id="bokja-basket-pop-title">Save your basket for later, and receive your unique 10% discount.</p>' +
          '<div class="bokja-basket-pop__field">' +
            '<input type="email" name="email" placeholder="Email address" aria-label="Email address" autocomplete="email" required>' +
            '<button type="submit" aria-label="Save my basket">&rarr;</button>' +
          '</div>' +
          '<p class="bokja-basket-pop__small" data-bokja-basket-save-error hidden>Please check the email address and try again.</p>' +
        '</form>' +
        '<div class="bokja-basket-pop__done">' +
          '<p class="bokja-basket-pop__done-text"></p>' +
          '<button type="button" class="bokja-basket-pop__go" data-bokja-basket-pop-close>Go to your basket</button>' +
        '</div>' +
      '</div>';
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || (event.target.closest && event.target.closest('[data-bokja-basket-pop-close]'))) dialog.close();
    });
    document.body.appendChild(dialog);
    return dialog;
  }

  // Pop-up FIRST, basket after (James, 2026-10-31: "The pop-up should trigger before the side drawer opens.
  // So the people put in their email, with the anticipation that they'll then go into the cart to use the
  // discount we sent them."). The drawer opens itself on cart:update when it carries auto-open
  // (assets/cart-drawer.js #handleCartAdd, a bubbling listener on document). This listener runs in the
  // CAPTURE phase, so it goes first: it lifts auto-open for this one event, shows the pop-up, and opens the
  // drawer when the pop-up closes (the cross, Escape, the backdrop, or "Go to your basket" after saving).
  document.addEventListener('cart:update', function (event) {
    var d = (event.detail && event.detail.data) || {};
    if (d.source !== 'product-form-component' || d.didError) return;
    if (!source || read(SAVED) || read(POPPED) || signedIn()) return;
    store(POPPED, '1');
    var drawer = document.querySelector('cart-drawer-component[auto-open]');
    if (drawer) {
      drawer.removeAttribute('auto-open');
      setTimeout(function () { drawer.setAttribute('auto-open', ''); }, 0);   // after this event only
    }
    var dialog = buildPop();
    dialog.addEventListener('close', function () {
      if (!document.documentElement.classList.contains('bokja-basket-saved')) publish('dismissed', 'pop-up');
      if (appliedCode) { refreshBasket(); return; }   // the drawer opens itself on a cart update and redraws with the 10% off
      if (drawer && typeof drawer.open === 'function') drawer.open();
    });
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    publish('shown', 'pop-up');
  }, true);

  // Each Klaviyo try stops after 8 s (2 Nov 2026): it settles even if the browser ignores the abort.
  var KLAVIYO_MS = 8000;

  function klaviyo(path, company, body) {
    var ctl = window.AbortController ? new AbortController() : null;
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { if (ctl) ctl.abort(); reject(new Error('klaviyo timeout')); }, KLAVIYO_MS);
      fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body),
        signal: ctl ? ctl.signal : undefined,
      }).then(function (r) {
        clearTimeout(timer);
        if (r.status === 202) resolve(r); else reject(new Error('klaviyo ' + r.status));
      }, function (e) { clearTimeout(timer); reject(e); });
    });
  }

  function imageAt(url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (!width) return url;   // the email sets size and crop (square, from the bottom, for cushions)
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  // 4. The code at once (James, 2026-10-31: "3.5 minutes is impossibly slow ... it needs to be instant", then
  //    "Yes, unique codes"). Bokja's server hands out the visitor's own code through vip.bokja.com (bokja-crm
  //    crm/basket_code.py: one code per address, five new an hour per visitor), the pop-up puts it on the basket
  //    and shows it, and the Klaviyo email carries the same code (event property Code). A typed address that is
  //    not real is fine (James: "they'll have to put in a correct email when they check out anyway"). Anything
  //    slow or refused falls back to the email alone, which then brings a code of its own.
  var CODE_URL = 'https://vip.bokja.com/basket-code';
  var appliedCode = '';

  function fetchCode(email, place) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 6000);
    return fetch(CODE_URL, { method: 'POST', mode: 'cors', credentials: 'omit', signal: ctl ? ctl.signal : undefined,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'email=' + encodeURIComponent(email) + '&source=' + encodeURIComponent(place) })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, j: j }; }, function () { return { status: r.status, j: null }; }); })
      .then(function (res) {
        clearTimeout(timer);
        var code = res.j && /^BOKJA[A-Z2-9]{6}$/.test(res.j.code || '') ? res.j.code : '';
        return { code: code, error: code ? '' : ((res.j && res.j.error) || 'down') };
      }, function () { clearTimeout(timer); return { code: '', error: 'down' }; });
  }

  function applyCode(code) {
    if (!code) return Promise.resolve(false);
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code && d.applicable; });
      }, function () { return false; });
  }

  function refreshBasket() {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: null, sourceId: 'bokja-basket-save', data: { source: 'bokja-basket-save' } } }));
  }

  // 5. The code first, the email after (2 Nov 2026). The code shows as soon as it is on the basket (or refused by
  //    it), never waiting for Klaviyo. Nothing promises an email: Klaviyo's 202 means it accepted the event, not
  //    that an email will go out (suppression and flow filters can still stop it). email_requested and
  //    email_failed are tracking steps only.
  //    The drawer keeps the confirmation through its re-renders and a refresh: an APPLIED code comes from the cart
  //    in Liquid (snippets/bokja-basket-save.liquid marks the box data-bokja-basket-done); a code on the basket
  //    that does not apply is kept for the tab (sessionStorage) and written back here after each re-render. With
  //    neither, the drawer shows the form again, never an empty confirmation.
  var CODE = 'bokja-basket-code';

  function showDone(box, code, applied) {
    if (!code) return;   // no code, no done text: the default is empty
    var line = applied ? 'Your 10% is now applied to your basket. Your code: ' + code + '.'
                       : 'Your 10% code: ' + code + '. Enter it at checkout.';
    var el = box.querySelector('.bokja-basket-pop__done-text') || box.querySelector('.bokja-basket-save__done');
    if (!el) return;
    el.textContent = line;
    box.setAttribute('data-bokja-basket-done', '');
  }

  // Every drawer box that the cart did not already confirm. After a save, `applied` is what the cart just said;
  // after a re-render it is false, because Liquid confirms every applied code itself.
  function fillDrawers(code, applied) {
    if (!/^BOKJA[A-Z2-9]{6}$/.test(code || '')) return;
    var boxes = document.querySelectorAll('.bokja-basket-save[data-bokja-basket-save]:not([data-bokja-basket-done])');
    for (var i = 0; i < boxes.length; i++) showDone(boxes[i], code, applied);
  }

  var watching = false;
  function watchDrawer() {
    if (watching || !window.MutationObserver) return;
    watching = true;
    var queued = false;
    var run = function () { queued = false; fillDrawers(read(CODE), false); };
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(run); else setTimeout(run, 0);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (read(CODE)) { fillDrawers(read(CODE), false); watchDrawer(); }

  // The Saved Basket event, in the background: the shopper already has the code.
  function sendBasket(email, company, locale, place, code, applied) {
    var saveEvent = function (body) { return klaviyo('events', company, body).catch(function () { return klaviyo('events', company, body); }); };
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) {
          return { ProductName: i.product_title + (i.variant_title ? ' - ' + i.variant_title : ''), URL: i.url, ImageURL: imageAt(i.image, 0),
                   Quantity: i.quantity, Price: i.final_price / 100, VariantID: i.variant_id, SKU: i.sku || '' };
        });
        if (!items.length) throw new Error('empty basket');
        var permalink = 'https://' + window.location.hostname + '/cart/' + cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',');
        return saveEvent({ data: { type: 'event', attributes: {
          properties: { Source: source || 'unknown', Offer: 'unique 10%', Place: place, Code: code || undefined, CodeApplied: applied, Items: items, ItemNames: items.map(function (i) { return i.ProductName; }), ItemCount: cart.item_count,
                        Currency: cart.currency, CartURL: permalink, $value: cart.total_price / 100 },
          metric: { data: { type: 'metric', attributes: { name: 'Saved Basket' } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: { $locale_language: locale, saved_basket_source: place, arrival_source: source || 'unknown' } } } },
          unique_id: (cart.token || 'cart') + ':' + Date.now(),
        } } });
      })
      .then(function () {
        publish('email_requested', place);   // Klaviyo accepted the event; no line on the page says more
        // identify only with marketing consent: klaviyo.js sets its own cookie
        try {
          var cp = window.Shopify && window.Shopify.customerPrivacy;
          var allowed = cp && typeof cp.marketingAllowed === 'function' ? cp.marketingAllowed() : false;
          if (allowed && window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email });
        } catch (e) { /* the email and the basket are already in Klaviyo */ }
      }, function () {
        publish('email_failed', place);   // the code is on the screen already
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var box = form && form.closest && form.closest('[data-bokja-basket-save]');
    if (!box) return;
    event.preventDefault();
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var note = form.querySelector('[data-bokja-basket-save-error]');
    var email = (input.value || '').trim();
    if (note) note.hidden = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { if (note) note.hidden = false; input.focus(); return; }
    var company = box.dataset.klaviyoCompany;
    var locale = (document.documentElement.lang || 'en').slice(0, 2);
    button.disabled = true;

    // NO newsletter sign-up (James, 2026-10-31: "We don't want to confirm a subscription ... This is not an
    // excuse to get permissions."). Until then this step joined the Email List (double opt-in), which sent
    // Klaviyo's confirmation email ahead of the code. Now the visitor only gets what they asked for: the
    // Saved Basket event creates or matches the profile and the flow sends the code email at once.
    var place = box.dataset.bokjaBasketPlace === 'popup' ? 'pop-up' : 'drawer';
    publish('submitted', place);

    var code = '';
    var applied = false;
    // No code, no promise: the code only ever comes from Bokja's server (31 Oct, evening: Klaviyo's own coupon codes
    // as a fallback made Klaviyo assign one to every email, and an empty Klaviyo pool would have stopped the email).
    fetchCode(email, place)
      .then(function (res) {
        if (!res.code) {
          publish('code_failed', place, { reason: res.error });
          var e = new Error(res.error); e.basket = res.error; throw e;
        }
        code = res.code;
        publish('code_issued', place);
        return applyCode(code);
      })
      .then(function (ok) {
        applied = ok;
        if (ok) appliedCode = code;
        publish('code_applied', place, { applied: ok });
        if (ok && place === 'drawer') refreshBasket();   // the drawer is open already: redraw it with the discount
        showDone(box, code, applied);   // at once: Klaviyo is not waited for
        store(SAVED, '1');
        store(CODE, code);
        document.documentElement.classList.add('bokja-basket-saved');
        fillDrawers(code, applied);   // the drawer's own box, before its next re-render
        watchDrawer();
        sendBasket(email, company, locale, place, code, applied);   // background, never returned
      })
      .then(null, function (err) {
        if (code) {   // the code is on the basket: say so rather than an error
          showDone(box, code, applied);
          store(SAVED, '1');
          store(CODE, code);
          document.documentElement.classList.add('bokja-basket-saved');
          return;
        }
        button.disabled = false;
        if (note) {
          note.textContent = err && err.basket === 'email' ? 'Please check the email address and try again.'
            : 'We could not fetch your code just now. Please try again in a moment.';
          note.hidden = false;
        }
      });
  });
})();
